import { render, staticRenderFns } from "./demandModal.vue?vue&type=template&id=1358e02b&scoped=true"
import script from "./demandModal.vue?vue&type=script&lang=js"
export * from "./demandModal.vue?vue&type=script&lang=js"
import style0 from "./demandModal.vue?vue&type=style&index=0&id=1358e02b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1358e02b",
  null
  
)

export default component.exports